import React from 'react'

const Combinations = () => {
    return (
        <>Combinations mobile</>
    )
}

export { Combinations }